import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '@/lib/firebase';

let currentUser: User | null = null;
let initialized = false;
let listeners: (() => void)[] = [];

export function getAuthUser(): User | null {
  return currentUser;
}

export function getAuthUID(): string | null {
  return currentUser?.uid ?? null;
}

export function isAuthLoaded(): boolean {
  return initialized;
}

export function onAuthReady(callback: () => void): () => void {
  if (initialized) {
    callback();
    return () => {};
  }
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((cb) => cb !== callback);
  };
}

onAuthStateChanged(auth, (user) => {
  currentUser = user;
  initialized = true;
  listeners.forEach((cb) => cb());
  listeners = []; // Clear one-time listeners
});


export { onAuthStateChanged };